import { useState } from "react";
import Overlay from "../components/sharedComponents/Overlay";

const useOverlay = () => {
  const [show, setShow] = useState(false);
  const showOverlay = () => setShow(true);
  const hideOverlay = () => setShow(false);

  const loader = show ? <Overlay /> : null;

  return { loader, showOverlay, hideOverlay };
};

export default useOverlay;
